// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file chat/v3/chat.proto (package chat.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Prompt } from "./chat_prompt_pb";
import { file_chat_v3_chat_prompt } from "./chat_prompt_pb";
import type { Message as Message$1 } from "./chat_messages_pb";
import { file_chat_v3_chat_messages } from "./chat_messages_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v3/chat.proto.
 */
export const file_chat_v3_chat: GenFile = /*@__PURE__*/
  fileDesc("ChJjaGF0L3YzL2NoYXQucHJvdG8SB2NoYXQudjMiLgoLQ2hhdFJlcXVlc3QSHwoGcHJvbXB0GAEgASgLMg8uY2hhdC52My5Qcm9tcHQiMgoMQ2hhdFJlc3BvbnNlEiIKCG1lc3NhZ2VzGAIgAygLMhAuY2hhdC52My5NZXNzYWdlIjAKDVN0cmVhbVJlcXVlc3QSHwoGcHJvbXB0GAEgASgLMg8uY2hhdC52My5Qcm9tcHQiSQoOU3RyZWFtUmVzcG9uc2USEwoLd29ya2Zsb3dfaWQYASABKAkSIgoIbWVzc2FnZXMYAiADKAsyEC5jaGF0LnYzLk1lc3NhZ2UiVgoTQ29udmVyc2F0aW9uUmVxdWVzdBIeCgdjaGF0X2lkGAEgASgJQg2atRgJc3RpZC5DaGF0Eh8KBmZvcm1hdBgCIAEoDjIPLmNoYXQudjMuRm9ybWF0IloKFENvbnZlcnNhdGlvblJlc3BvbnNlEh4KB2NoYXRfaWQYASABKAlCDZq1GAlzdGlkLkNoYXQSIgoIbWVzc2FnZXMYAiADKAsyEC5jaGF0LnYzLk1lc3NhZ2UiVQoVU3RyZWFtUGxheWJhY2tSZXF1ZXN0EiQKCm1lc3NhZ2VfaWQYASABKAlCEJq1GAxzdGlkLk1lc3NhZ2USFgoOcGxheWJhY2tfc3BlZWQYAiABKAIiUQoWU3RyZWFtUGxheWJhY2tSZXNwb25zZRITCgt3b3JrZmxvd19pZBgBIAEoCRIiCghtZXNzYWdlcxgCIAMoCzIQLmNoYXQudjMuTWVzc2FnZSpNCgZGb3JtYXQSFgoSRk9STUFUX1VOU1BFQ0lGSUVEEAASDwoLRk9STUFUX1RFWFQQARIUChBGT1JNQVRfUklDSF9URVhUEAIiBAgDEBQyqQIKC0NoYXRTZXJ2aWNlEjUKBENoYXQSFC5jaGF0LnYzLkNoYXRSZXF1ZXN0GhUuY2hhdC52My5DaGF0UmVzcG9uc2UiABI9CgZTdHJlYW0SFi5jaGF0LnYzLlN0cmVhbVJlcXVlc3QaFy5jaGF0LnYzLlN0cmVhbVJlc3BvbnNlIgAwARJNCgxDb252ZXJzYXRpb24SHC5jaGF0LnYzLkNvbnZlcnNhdGlvblJlcXVlc3QaHS5jaGF0LnYzLkNvbnZlcnNhdGlvblJlc3BvbnNlIgASVQoOU3RyZWFtUGxheWJhY2sSHi5jaGF0LnYzLlN0cmVhbVBsYXliYWNrUmVxdWVzdBofLmNoYXQudjMuU3RyZWFtUGxheWJhY2tSZXNwb25zZSIAMAFCV1pVZ2l0aHViLmNvbS9TdG9yeXRlbGwtYWkvc3Rvcnl0ZWxsLWFpLXBsYXRmb3JtL3BrZy9nby9kb21haW5zL2NwL2dlbi9wYi9jaGF0L3YzO2NoYXRWM2IGcHJvdG8z", [file_chat_v3_chat_prompt, file_chat_v3_chat_messages, file_common_v3_common]);

/**
 * @generated from message chat.v3.ChatRequest
 */
export type ChatRequest = Message<"chat.v3.ChatRequest"> & {
  /**
   * @generated from field: chat.v3.Prompt prompt = 1;
   */
  prompt: Prompt;
};

/**
 * Describes the message chat.v3.ChatRequest.
 * Use `create(ChatRequestSchema)` to create a new message.
 */
export const ChatRequestSchema: GenMessage<ChatRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 0);

/**
 * @generated from message chat.v3.ChatResponse
 */
export type ChatResponse = Message<"chat.v3.ChatResponse"> & {
  /**
   * @generated from field: repeated chat.v3.Message messages = 2;
   */
  messages: Message$1[];
};

/**
 * Describes the message chat.v3.ChatResponse.
 * Use `create(ChatResponseSchema)` to create a new message.
 */
export const ChatResponseSchema: GenMessage<ChatResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 1);

/**
 * @generated from message chat.v3.StreamRequest
 */
export type StreamRequest = Message<"chat.v3.StreamRequest"> & {
  /**
   * @generated from field: chat.v3.Prompt prompt = 1;
   */
  prompt: Prompt;
};

/**
 * Describes the message chat.v3.StreamRequest.
 * Use `create(StreamRequestSchema)` to create a new message.
 */
export const StreamRequestSchema: GenMessage<StreamRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 2);

/**
 * @generated from message chat.v3.StreamResponse
 */
export type StreamResponse = Message<"chat.v3.StreamResponse"> & {
  /**
   * The ID of the workflow processing this stream
   *
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * Message(s) in this response
   *
   * @generated from field: repeated chat.v3.Message messages = 2;
   */
  messages: Message$1[];
};

/**
 * Describes the message chat.v3.StreamResponse.
 * Use `create(StreamResponseSchema)` to create a new message.
 */
export const StreamResponseSchema: GenMessage<StreamResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 3);

/**
 * @generated from message chat.v3.ConversationRequest
 */
export type ConversationRequest = Message<"chat.v3.ConversationRequest"> & {
  /**
   * Format: ^chat_[a-z0-9]{20}$
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * @generated from field: chat.v3.Format format = 2;
   */
  format: Format;
};

/**
 * Describes the message chat.v3.ConversationRequest.
 * Use `create(ConversationRequestSchema)` to create a new message.
 */
export const ConversationRequestSchema: GenMessage<ConversationRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 4);

/**
 * @generated from message chat.v3.ConversationResponse
 */
export type ConversationResponse = Message<"chat.v3.ConversationResponse"> & {
  /**
   * Format: ^chat_[a-z0-9]{20}$
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * @generated from field: repeated chat.v3.Message messages = 2;
   */
  messages: Message$1[];
};

/**
 * Describes the message chat.v3.ConversationResponse.
 * Use `create(ConversationResponseSchema)` to create a new message.
 */
export const ConversationResponseSchema: GenMessage<ConversationResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 5);

/**
 * @generated from message chat.v3.StreamPlaybackRequest
 */
export type StreamPlaybackRequest = Message<"chat.v3.StreamPlaybackRequest"> & {
  /**
   * Format: ^message_[a-z0-9]{20}$
   *
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: float playback_speed = 2;
   */
  playbackSpeed: number;
};

/**
 * Describes the message chat.v3.StreamPlaybackRequest.
 * Use `create(StreamPlaybackRequestSchema)` to create a new message.
 */
export const StreamPlaybackRequestSchema: GenMessage<StreamPlaybackRequest> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 6);

/**
 * @generated from message chat.v3.StreamPlaybackResponse
 */
export type StreamPlaybackResponse = Message<"chat.v3.StreamPlaybackResponse"> & {
  /**
   * The ID of the workflow processing this stream
   *
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * Message(s) in this response
   *
   * @generated from field: repeated chat.v3.Message messages = 2;
   */
  messages: Message$1[];
};

/**
 * Describes the message chat.v3.StreamPlaybackResponse.
 * Use `create(StreamPlaybackResponseSchema)` to create a new message.
 */
export const StreamPlaybackResponseSchema: GenMessage<StreamPlaybackResponse> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat, 7);

/**
 * Format defines the format of the conversation.
 *
 * @generated from enum chat.v3.Format
 */
export enum Format {
  /**
   * @generated from enum value: FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FORMAT_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: FORMAT_RICH_TEXT = 2;
   */
  RICH_TEXT = 2,
}

/**
 * Describes the enum chat.v3.Format.
 */
export const FormatSchema: GenEnum<Format> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat, 0);

/**
 * ChatService provides methods for creating, continuing, and retrieving
 * conversations.
 *
 * @generated from service chat.v3.ChatService
 */
export const ChatService: GenService<{
  /**
   * Chat creates or advances a conversation by accepting a prompt and
   * returning completed messages.
   *
   * The prompt can be a text or a rich text document. When working in rich-text
   * the message will be returned as a rich-text document. When working in text
   * the message will be returned as a text document which may contain markdown.
   *
   * Operations block until the message is completed.
   *
   * To create a new chat, provide a empty string or zero ID for the
   * parent message (example: "message_00000000000000000000").
   *
   * The caller must be authenticated.
   *
   * @generated from rpc chat.v3.ChatService.Chat
   */
  chat: {
    methodKind: "unary";
    input: typeof ChatRequestSchema;
    output: typeof ChatResponseSchema;
  },
  /**
   * Stream creates or advances a conversation by accepting a prompt and
   * streaming updates as messages are completed.
   *
   * The prompt can be a text or a rich text document. When streaming
   * rich-text delta updates may be sent to allow the client render incremental
   * progress until the message (or block) is done. In such cases, the done
   * message will contain the rich-text document with all the updates applied.
   *
   * To create a new chat, provide a empty string or zero ID for the
   * parent message (example: "message_00000000000000000000").
   *
   * The caller must be authenticated.
   *
   * @generated from rpc chat.v3.ChatService.Stream
   */
  stream: {
    methodKind: "server_streaming";
    input: typeof StreamRequestSchema;
    output: typeof StreamResponseSchema;
  },
  /**
   * Conversation retrieves a conversation by its ID. Clients may request either
   * a text or a rich text document. Conversations that were in rich-text
   * may be requested as text; however, messages that occurred as text will
   * be returned as text even if the caller asks for rich-text in this
   * request.
   *
   * The caller must be authenticated.
   *
   * @generated from rpc chat.v3.ChatService.Conversation
   */
  conversation: {
    methodKind: "unary";
    input: typeof ConversationRequestSchema;
    output: typeof ConversationResponseSchema;
  },
  /**
   * StreamPlayback retrieves a message by its ID and streams it back to the
   * client. This is useful for playback of messages that were previously
   * streamed. The client can specify a playback speed to control how fast the
   * message is played back. The playback speed is a multiplier of the original
   * message speed, where 1.0 is the original speed, 0.5 is half speed, and 2.0
   * is double speed.
   *
   * This method is useful for debugging and demonstration purposes.
   *
   * @generated from rpc chat.v3.ChatService.StreamPlayback
   */
  streamPlayback: {
    methodKind: "server_streaming";
    input: typeof StreamPlaybackRequestSchema;
    output: typeof StreamPlaybackResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chat_v3_chat, 0);

